import React, { useState, useEffect, useReducer } from 'react'
import { Loader, Message, Modal, Panel, Table } from 'rsuite'
import ViewButton from '../../buttons/viewButton/ViewButton'
import CancelButton from '../../buttons/cancelButton/CancelButton'
import { getCheckLeavedate } from '../../../redux/actions/approveProject'
import moment from 'moment'

export default function ApproverListDetail({ dataList, header }) {
  // const [formSchema, setFormSchema] = useState(schema)
  const { Column, HeaderCell, Cell } = Table
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowLeaveDate, setIsShowLeaveDate] = useState(false)
  const [tableData, setTableData] = useState([])
  // console.log('tableData==>', tableData)
  const [_, forceUpdate] = useReducer((x) => x + 1, 0)

  // useEffect(() => {
  //   if (dataList.length > 0) {
  //     setTimeout(()=>{
  //       forceUpdate()
  //     }, 10)
     
  //   }
  // }, [dataList])

  useEffect(() => {
    if (tableData.length > 0) {
      setTimeout(()=>{
        forceUpdate()
      }, 10)
     
    }
  }, [tableData])

  const handleClickDetailModal = (rowData) => {
    // console.log('rowData => ', rowData)
    setIsShowLeaveDate(true)
    handleCallCheckLeaveDate(rowData.employeeCode)
  }

  const handleCallCheckLeaveDate = async (employeeCode) => {
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await getCheckLeavedate(employeeCode)
      if (response) {
        setIsShowLeaveDate(true)
        setTableData(response)
      } else {
        setTableData([])
      }
    } catch (error) {
      setIsError(true)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <>
      <Panel
        className="grantee-profile-info"
        //shaded
        header={header}
        //bordered
        collapsible
        defaultExpanded
        style={{ marginBottom: 10 }}
        
      >
        {dataList?.some((item) => item.approveLevel === 1) && (
          <>
            <b>รายชื่อสายอนุมัติ ผู้ให้ความเห็นขั้นต้น</b>
            <Table
              autoHeight
              minHeight={100}
              data={dataList.filter((item) => item.approveLevel === 1)}
              wordWrap
              onDataUpdated={()=>{
                setTimeout(() => {
                  forceUpdate()
                }, 100)
              }}
              // rowHeight={60}
            >
              <Column width={80} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1
                  }}
                </Cell>
              </Column>
              <Column width={260}>
                <HeaderCell>
                  <span>ชื่อ-สกุล</span>
                </HeaderCell>
                <Cell dataKey="fullName" />
              </Column>
              <Column width={320}>
                <HeaderCell>
                  <span>ตำแหน่ง</span>
                </HeaderCell>
                <Cell dataKey="position" />
              </Column>
              {/* <Column width={180}>
            <HeaderCell>
              <span>สิทธิ์การอนุมัติ</span>
            </HeaderCell>
            <Cell dataKey="approveLevelName" />
          </Column> */}
              <Column minWidth={250} flexGrow={1}>
                <HeaderCell>
                  <span>วันที่ลาหยุด</span>
                </HeaderCell>
                {/* <Cell dataKey="leaveDate" /> */}
                <Cell>
                  {(rowData) => {
                    return <span dangerouslySetInnerHTML={{ __html: rowData.leaveDate }} />
                  }}
                </Cell>
                {/* <Cell>
              {(rowData) => {
                return (
                  <>
                    <ViewButton
                      icon="eye"
                      onClick={() => {
                        handleClickDetailModal(rowData)
                      }}
                    >
                      แสดง
                    </ViewButton>
                  </>
                )
              }}
            </Cell> */}
              </Column>
            </Table>
            <br />
            <br />
          </>
        )}

        {dataList?.some((item) => item.approveLevel === 2) && (
          <>
            <b>รายชื่อสายอนุมัติ ผู้มีอำนาจอนุมัติ</b>
            <Table
              autoHeight
              minHeight={100}
              data={dataList.filter((item) => item.approveLevel === 2)}
              wordWrap
              onDataUpdated={()=>{
                setTimeout(() => {
                  forceUpdate()
                }, 100)
              }}
              // rowHeight={60}
            >
              <Column width={80} align="center">
                <HeaderCell>ลำดับ</HeaderCell>
                <Cell>
                  {(_, index) => {
                    return index + 1
                  }}
                </Cell>
              </Column>
              <Column width={260}>
                <HeaderCell>
                  <span>ชื่อ-สกุล</span>
                </HeaderCell>
                <Cell dataKey="fullName" />
              </Column>
              <Column width={320}>
                <HeaderCell>
                  <span>ตำแหน่ง</span>
                </HeaderCell>
                <Cell dataKey="position" />
              </Column>
              {/* <Column width={180}>
            <HeaderCell>
              <span>สิทธิ์การอนุมัติ</span>
            </HeaderCell>
            <Cell dataKey="approveLevelName" />
          </Column> */}
              <Column minWidth={250} flexGrow={1}>
                <HeaderCell>
                  <span>วันที่ลาหยุด</span>
                </HeaderCell>
                {/* <Cell dataKey="leaveDate" /> */}
                <Cell>
                  {(rowData) => {
                    return <span dangerouslySetInnerHTML={{ __html: rowData.leaveDate }} />
                  }}
                </Cell>
              </Column>
            </Table>
          </>
        )}
      </Panel>

      {/* Modal วันลา */}
      <Modal
        backdrop="static"
        full
        show={isShowLeaveDate}
        onHide={() => {
          setIsShowLeaveDate(false)
        }}
      >
        <Modal.Header>
          <Modal.Title style={{ paddingTop: 10 }}>{`วันที่ลาหยุด ${
            tableData?.employeeName || ''
          }`}</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Table autoHeight minHeight={200} data={tableData.leaveDateList} wordWrap>
            <Column width={80} align="center">
              <HeaderCell>ลำดับ</HeaderCell>
              <Cell>
                {(_, index) => {
                  return index + 1
                }}
              </Cell>
            </Column>
            <Column width={260}>
              <HeaderCell>
                <span>วันที่ลาหยุด</span>
              </HeaderCell>
              <Cell dataKey="leaveDate" />
            </Column>
            <Column width={260}>
              <HeaderCell>
                <span>เวลาที่ลาหยุด</span>
              </HeaderCell>
              <Cell>{(rowData) => `${rowData.startTime || ''} - ${rowData.endTime || ''}`}</Cell>
            </Column>
          </Table>
        </Modal.Body>

        <Modal.Footer>
          <CancelButton
            onClick={() => {
              setIsShowLeaveDate(false)
            }}
          >
            ปิด
          </CancelButton>
        </Modal.Footer>
      </Modal>
    </>
  )
}
